import React from "react";
import T from "prop-types";
import { Field } from "redux-form";
import { FormRow, TextArea } from "MODULES/shared/components/Forms";
import { Col } from "react-bootstrap";

export function Notes({ canEditNotes, canEditInternalNotes, editing }) {
  return (
    <div>
      {!editing && <h5 className="h4">Notes</h5>}
      <FormRow>
        <Col md={6}>
          <Field
            name="internal_note"
            component={TextArea}
            rows={5}
            label="Internal Note"
            disabled={!canEditNotes && !canEditInternalNotes}
          />
        </Col>
        <Col md={6}>
          <Field
            name="external_note"
            component={TextArea}
            rows={5}
            label="External Note"
            disabled={!canEditNotes}
          />
        </Col>
      </FormRow>
    </div>
  );
}

Notes.propTypes = {
  canEditNotes: T.bool,
  canEditInternalNotes: T.bool,
  editing: T.bool
};

export default Notes;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Form/Notes.jsx